// extracted by mini-css-extract-plugin
module.exports = {"LogoBrand":"LogoBrand-module_LogoBrand_1UqOo"};